import { Divider, Typography } from 'antd';
import { snakeCase } from 'lodash';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import { PrereleaseFeature } from 'hooks/use-feature';

const FeatureFlagListStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;

  h2,
  .ant-divider.ant-divider-horizontal {
    padding: 0;
    margin: 0.5rem;
  }

  ul li {
    padding: 0.25em;
    list-style: none;
    .feature-name {
      margin-left: 0.5rem;
    }
  }
`;

export const FeatureFlagList: React.FC = () => {
  const featureFlags = Object.values(PrereleaseFeature).map((feature) => {
    return {
      name: feature,
      enabled:
        localStorage.getItem(`__features.v2.${snakeCase(feature)}`) === 'true',
    };
  });

  const [features, setFeatures] = useState(featureFlags);

  // update feature flag in local storage
  const updateFeatureFlag = (feature: { name: string; enabled: boolean }) => {
    // update state with new feature flag
    setFeatures(
      features.map((f) => {
        if (f.name === feature.name) {
          return { ...f, enabled: !feature?.enabled };
        }

        return f;
      }),
    );

    localStorage.setItem(
      `__features.v2.${snakeCase(feature.name)}`,
      JSON.stringify(!feature.enabled),
    );
  };

  return (
    <FeatureFlagListStyled>
      <h2>
        <FormattedMessage id="featureflags_title" />
      </h2>
      <Divider />
      <ul>
        {features.map((feature) => (
          <li key={feature.name}>
            <Checkbox
              checked={feature.enabled}
              onChange={() => updateFeatureFlag(feature)}
              name={feature.name}
            />

            <Typography.Text className="feature-name">
              {feature.name.replace(/([A-Z])/g, ' $1')}
            </Typography.Text>
          </li>
        ))}
      </ul>
    </FeatureFlagListStyled>
  );
};
